var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MemberProfileEdit/MemberProfileEditCreditsAdd.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEditCreditsAdd.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data", "item"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("item", Object.prototype.hasOwnProperty.call(kwargs, "item") ? kwargs["item"] : {});var t_5 = "";t_5 += "\n    <div class=\"MemberProfileEditCreditsAdd\">\n        <div class=\"MemberProfileEditCreditsAdd-body MemberProfileEdit-scrollbox\" data-state=\"";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"url") || !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id")) {
t_5 += "imdb";
;
}
else {
t_5 += "custom";
;
}
t_5 += "\">\n            <form class=\"MemberProfileEditCreditsAdd-body-form\">\n\n                <input type=\"hidden\" name=\"id\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id")) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += ">\n                <input type=\"hidden\" name=\"cover\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"cover")) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(env.getFilter("tojson").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"cover")), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += ">\n\n                <div class=\"MemberProfileEditCreditsAdd-info\">\n                    <div class=\"MemberProfileEditCreditsAdd-infoIcon\">?</div>\n                    <div class=\"MemberProfileEditCreditsAdd-infoPopup\">\n                        <span>You can add any credit by simply copying and pasting the production’s corresponding IMDB link and hitting enter. If your production is not listed on IMDB, click the link below the input field, and you will be able to add the production yourself.</span>\n                        <div class=\"MemberProfileEditCreditsAdd-infoPopupCorner\"></div>\n                    </div>\n                </div>\n\n                <div class=\"MemberProfileEditCreditsAdd-body-form-leftCol\">\n\n                    ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"url")) {
t_5 += "\n                        <div class=\"MemberProfileEditCreditsAdd-body-form-inputWrapper\" data-field=\"url\">\n                            <div class=\"MemberProfileEditCreditsAdd-body-form-input-label\">\n                                PRODUCTION’S IMDB LINK\n                            </div>\n                            <input class=\"MemberProfileEditCreditsAdd-body-form-input";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"url")) {
t_5 += " disabled";
;
}
t_5 += "\" type=\"text\" name=\"url\"\n                                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"url")) {
t_5 += " value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"url"), env.opts.autoescape);
t_5 += "\" disabled readonly";
;
}
t_5 += ">\n\n                        </div>\n                    ";
;
}
t_5 += "\n\n                    <div class=\"MemberProfileEditCreditsAdd-body-form-inputWrapper\" data-field=\"title\" style=\"display: ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id")) {
t_5 += "none";
;
}
else {
t_5 += "block";
;
}
t_5 += "\">\n                        <div class=\"MemberProfileEditCreditsAdd-body-form-input-label\">\n                            Production Title\n                        </div>\n                        <input class=\"MemberProfileEditCreditsAdd-body-form-input";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id")) {
t_5 += " disabled";
;
}
t_5 += "\" type=\"text\" name=\"title\"\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"title")) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"title"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += " ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id")) {
t_5 += " disabled readonly";
;
}
t_5 += ">\n                    </div>\n\n                    ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id")) {
t_5 += "\n                        <div class=\"MemberProfileEditCreditsAdd-body-form-inputWrapper MemberProfileEditCreditsAdd-body-form-inputWrapper--switchers\">\n                            <div class=\"MemberProfileEditCreditsAdd-body-form-switcher\" data-type=\"custom\">Is your production not listed on IMDB?</div>\n                            <div class=\"MemberProfileEditCreditsAdd-body-form-switcher\" data-type=\"imdb\">is your production listed on IMDB?</div>\n                        </div>\n                    ";
;
}
t_5 += "\n\n                    <div class=\"MemberProfileEditCreditsAdd-body-form-inputWrapper\">\n                        <div class=\"MemberProfileEditCreditsAdd-body-form-input-label\">\n                            Your Role\n                        </div>\n                        <input class=\"MemberProfileEditCreditsAdd-body-form-input\" type=\"text\" name=\"role\"\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"role")) {
t_5 += " value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"role"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += ">\n                    </div>\n                    <div class=\"MemberProfileEditCreditsAdd-body-form-inputWrapper\">\n                        <div class=\"MemberProfileEditCreditsAdd-body-form-input-label\">\n                            SEASON(S) / EPISODE(S)\n                        </div>\n                        <input class=\"MemberProfileEditCreditsAdd-body-form-input\" type=\"text\" name=\"season\"\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"season")) {
t_5 += " value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"season"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += ">\n                    </div>\n                </div>\n\n                <div class=\"MemberProfileEditCreditsAdd-body-form-rightCol\">\n                    <div class=\"MemberProfileEditCreditsAdd-body-form-inputWrapper\">\n                        <div class=\"MemberProfileEditCreditsAdd-body-form-input-label\">\n                            Cover Preview\n                        </div>\n                        <div class=\"MemberProfileEditCreditsAdd-body-form-input-cover\" data-empty=\"";
t_5 += runtime.suppressValue((lineno = 67, colno = 106, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["img/no-cover.png"])), env.opts.autoescape);
t_5 += "\">\n                            <img ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"cover")) {
t_5 += "src=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"cover")),"w680_url"), env.opts.autoescape);
t_5 += "\"";
;
}
else {
t_5 += "src=\"";
t_5 += runtime.suppressValue((lineno = 68, colno = 93, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["img/no-cover.png"])), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += ">\n                            <div class=\"MemberProfileEditCreditsAdd-loader\"></div>\n                        </div>\n                    </div>\n                </div>\n\n            </form>\n        </div>\n        <div class=\"MemberProfileEditCreditsAdd-buttons\">\n            <div class=\"MemberProfileEditCreditsAdd-buttons-button MemberProfileEditCreditsAdd-buttons-button--cancel\">\n                cancel\n            </div>\n            <div class=\"MemberProfileEditCreditsAdd-buttons-button MemberProfileEditCreditsAdd-buttons-button--save\">\n                save\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("MemberProfileEditCreditsAdd");
context.setVariable("MemberProfileEditCreditsAdd", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MemberProfileEdit/MemberProfileEditCreditsAdd.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditCreditsAdd.jinja
// module id = 111
// module chunks = 0